module.exports = __webpack_public_path__ + "static/media/about-page-background.eaac4c00.svg";